import { useEditorStore } from '../../state/editorStore';
import { ResizeHandle } from '../layout/ResizeHandle';
import { ColorPanel } from '../panels/ColorPanel';
import { KeyframesPanel } from '../panels/KeyframesPanel';
import { ScopesPanel } from '../panels/ScopesPanel';
import { ViewerPanel } from '../panels/ViewerPanel';

/** Shared Color Suite chrome: Scopes | Viewer | Color / Keys (resizable). */
export function ColorSuiteLayout() {
  const scopesW = useEditorStore((s) => s.panelSizes.colorScopesWidth);
  const toolsW = useEditorStore((s) => s.panelSizes.colorToolsWidth);
  const keysH = useEditorStore((s) => s.panelSizes.colorKeysHeight);
  const setPanelSize = useEditorStore((s) => s.setPanelSize);

  return (
    <div className="flex min-h-0 min-w-0 flex-1">
      <div
        className="flex h-full min-h-0 shrink-0 flex-col border-r border-hairline"
        style={{ width: scopesW }}
      >
        <div className="min-h-0 flex-1 overflow-hidden">
          <ScopesPanel />
        </div>
      </div>
      <ResizeHandle
        orientation="vertical"
        value={scopesW}
        min={180}
        max={520}
        onChange={(v) => setPanelSize('colorScopesWidth', v)}
      />

      <div className="flex min-h-0 min-w-0 flex-1 flex-col">
        <ViewerPanel />
      </div>

      <ResizeHandle
        orientation="vertical"
        value={toolsW}
        min={260}
        max={640}
        invert
        onChange={(v) => setPanelSize('colorToolsWidth', v)}
      />
      <div
        className="flex h-full min-h-0 shrink-0 flex-col border-l border-hairline"
        style={{ width: toolsW }}
      >
        <div className="min-h-0 flex-1 overflow-hidden">
          <ColorPanel />
        </div>
        <ResizeHandle
          orientation="horizontal"
          value={keysH}
          min={96}
          max={360}
          invert
          onChange={(v) => setPanelSize('colorKeysHeight', v)}
        />
        <div
          className="min-h-0 shrink-0 overflow-hidden border-t border-hairline"
          style={{ height: keysH }}
        >
          <KeyframesPanel />
        </div>
      </div>
    </div>
  );
}
